/**
 * @description: 公共配置
 */

// 接口域名
const ENV_URL = {
  // 生产环境
  production: {
    baseURL: 'https://flms-api.prd.qiaozuji.com',
    cdnURL: 'https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5'
  },
  // uat环境
  uat: {
    baseURL: 'https://flms-api.uat.qiaozuji.com',
    cdnURL: 'https://uat-qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5'
  },
  // 测试环境
  test: {
    baseURL: 'https://flms-api.test.qiaozuji.com',
    cdnURL: 'https://test-qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5'
  },
  // 开发环境
  development: {
    // baseURL: 'http://172.18.0.199:30010',
    baseURL: 'https://flms-api.test.qiaozuji.com',
    cdnURL: 'https://test-qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5'
  }
};

const BASE_URL = ENV_URL[process.env.VUE_APP_DATA_ENV].baseURL;
const CDN_URL = ENV_URL[process.env.VUE_APP_DATA_ENV].cdnURL;

module.exports = {
  BASE_URL,
  ENV_URL,
  CDN_URL
};
